import api from "@/lib/api";

let queue = [];
let timer = null;

function flush() {
  if (!queue.length) return;
  const events = queue;
  queue = [];
  api.post("/track", { events }).catch(() => {});
}

function push(t, n, p) {
  queue.push({ t, n: n || "", p: p || (typeof window !== "undefined" ? window.location.pathname : ""), ts: new Date().toISOString() });
  if (queue.length >= 12) { clearTimeout(timer); flush(); }
  else { clearTimeout(timer); timer = setTimeout(flush, 4000); }
}

export const trackPage = (name, path) => push("page", name, path);
export const trackClick = (name) => push("click", name);

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", flush);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
}
